var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.id === 'parts')?_c('part-master'):(_vm.id === 'assets')?_c('asset-config'):(_vm.id === 'import')?_c('import-plans'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }